// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-component-main {
  position: relative;
  width: 100%;
  height: 100%;
}
.thumbnail-layer {
  justify-content: center;
  z-index: 2;
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  cursor: pointer;
  align-items: center;
  display: flex;
}
.video-element {
  width: 100%;
  height: 100%;
  z-index: 1;
  object-fit: cover;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/jack-video/Video.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,iBAAiB;AACnB","sourcesContent":[".video-component-main {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.thumbnail-layer {\n  justify-content: center;\n  z-index: 2;\n  position: absolute;\n  inset: 0;\n  background-size: cover;\n  background-position: center;\n  cursor: pointer;\n  align-items: center;\n  display: flex;\n}\n.video-element {\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  object-fit: cover;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
